import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["delay"],
  _excluded2 = ["delay"];
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import TimeDelay from 'automation-ui-flow-core/fields/time/TimeDelay';
export default class DelayActionMetadata extends createImmutableObjectClass({
  actionType: ActionTypes.DELAY,
  delay: {}
}, {
  fromJSON: _ref => {
    let {
        delay
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return Object.assign({
      delay: new TimeDelay(delay)
    }, rest);
  },
  toJSON: _ref2 => {
    let {
        delay
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return Object.assign({
      delay: delay && delay.toJSON()
    }, rest);
  }
}) {
  setTimeDelay(delay) {
    return this.set('delay', delay);
  }
}